import { render, staticRenderFns } from "./VendedoresModal.vue?vue&type=template&id=7d5a56fe&scoped=true"
import script from "./VendedoresModal.vue?vue&type=script&lang=js"
export * from "./VendedoresModal.vue?vue&type=script&lang=js"
import style0 from "./VendedoresModal.vue?vue&type=style&index=0&id=7d5a56fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5a56fe",
  null
  
)

export default component.exports